import React, { Component } from 'react';

import Button from 'components/cosmos/button/button';
import { Dropdown } from 'components/cosmos/v2/dropdown';
import MoreOptionsButton from 'components/moreOptionsButton';
import { translate } from 'components/translate';
import { inject, observer } from 'mobx-react';
import { PlayerReportModal } from 'modules/player';
import PropTypes from 'prop-types';

@translate()
@inject((stores) => ({
  isMobile: stores.UiStore.isMobile
}))
@observer
export default class FileSectionHeaderActions extends Component {
  state = {
    removeModal: false,
    replaceModal: false
  };

  static defaultProps = {
    changeLabel: 'general.change',
    removeLabel: 'general.remove',
    downloadLabel: 'general.download'
  };

  static propTypes = {
    changeLabel: PropTypes.string,
    removeLabel: PropTypes.string,
    downloadLabel: PropTypes.string,
    showReports: PropTypes.bool,
    reportsLabel: PropTypes.string,
    mediaId: PropTypes.string,
    download: PropTypes.func,
    remove: PropTypes.func,
    replace: PropTypes.func,
    FileRemoveModal: PropTypes.func,
    FileReplaceModal: PropTypes.func,
    isMobile: PropTypes.bool
  };

  get actionsContextMenu() {
    const { changeLabel, removeLabel, downloadLabel, download } = this.props;

    const actions = [
      {
        onClick: this.onClickReplace,
        icon: ['fal', 'arrows-rotate'],
        label: changeLabel
      },
      {
        onClick: this.onClickRemove,
        icon: ['fal', 'trash'],
        label: removeLabel
      }
    ];

    download &&
      actions.unshift({
        onClick: this.onClickDownload,
        icon: ['far', 'download'],
        label: downloadLabel
      });

    return actions;
  }

  get actionsStandard() {
    const { showReports, reportsLabel } = this.props;
    const actions = [];

    showReports &&
      reportsLabel &&
      actions.unshift({
        onClick: this.onClickRetentionModal,
        icon: ['fal', 'chart-line'],
        label: reportsLabel
      });

    return actions;
  }

  get actions() {
    return [...this.actionsContextMenu, ...this.actionsStandard];
  }

  render() {
    return (
      <div className="file__section__header__actions">
        {this.renderModals()}

        {this.props.isMobile
          ? this.renderActionsContextMenu(this.actions)
          : this.renderActions()}
      </div>
    );
  }

  renderActions() {
    const { t } = this.props;

    return (
      <>
        {this.actionsStandard.map(({ onClick, icon, label }) => (
          <Button
            key={label}
            icon={icon}
            type="button"
            variation="tertiary"
            onClick={onClick}
          >
            {t(label)}
          </Button>
        ))}
        {this.renderActionsContextMenu(this.actionsContextMenu)}
      </>
    );
  }

  renderActionsContextMenu(actions) {
    const { t } = this.props;

    return (
      <Dropdown position="left">
        <MoreOptionsButton label={t('general.more_options')} />
        <Dropdown.Menu>
          {actions.map((item) => (
            <Dropdown.MenuItem
              key={item.label}
              onClick={item.onClick}
              icon={item.icon}
              className="_py-4"
              role="button"
            >
              {t(item.label)}
            </Dropdown.MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderModals() {
    const { FileRemoveModal, FileReplaceModal } = this.props;
    const { removeModal, replaceModal, retentionModal } = this.state;

    return (
      <>
        {removeModal && (
          <FileRemoveModal
            onConfirm={this.onConfirmRemove}
            onClose={this.onCloseRemove}
          />
        )}
        {replaceModal && (
          <FileReplaceModal
            onConfirm={this.onConfirmReplace}
            onClose={this.onCloseReplace}
          />
        )}
        {retentionModal && (
          <PlayerReportModal
            mediaId={this.props.mediaId}
            onClose={this.onCloseRetentionModal}
          />
        )}
      </>
    );
  }

  onClickRetentionModal = () => {
    this.setState({ retentionModal: true });
  };

  onCloseRetentionModal = () => {
    this.setState({ retentionModal: false });
  };

  onConfirmRemove = () => {
    const { remove } = this.props;

    remove && remove();
  };

  onConfirmReplace = () => {
    const { replace } = this.props;

    replace && replace();
  };

  onClickDownload = () => {
    const { download } = this.props;

    download && download();
  };

  onClickRemove = () => {
    this.setState({ removeModal: true });
  };

  onClickReplace = () => {
    this.setState({ replaceModal: true });
  };

  onCloseRemove = () => {
    this.setState({ removeModal: false });
  };

  onCloseReplace = () => {
    this.setState({ replaceModal: false });
  };
}
